export default __webpack_public_path__ + "static/media/Gauntlets of the Martial Paragon.e7a813e8.jpg";